import React, { useContext, useEffect, useState } from "react";
import PrimaryHeading from "../../../utils/PrimaryHeading/PrimaryHeading";
import { FAQuestions } from "../../../Mock/Learn";
import { IoIosArrowDown } from "react-icons/io";
import clsx from "clsx";
import Timer from "../../../main/Timer/Timer";
import { FaHandPointRight } from "react-icons/fa";

import { motion } from "framer-motion";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import { MyContext } from "../../../pages/Funnel";

const ProgramContent = ({ id }) => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/program_content_get/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && !isError && state.length !== 0 && (
        <section className="max-w-7xl m-auto my-16 bg-white py-12 px-5 rounded-xl">
          <div className="flex justify-center mb-12">
            <PrimaryHeading>Program Content</PrimaryHeading>
          </div>
          <div className="space-y-4">
            {state.map((val, index) => (
              <Child {...val} key={index} index={index} />
            ))}
          </div>
          <div className="mt-10 flex flex-col items-center justify-center">
            <Timer />
            <PrimaryBtn>Begin Your Course</PrimaryBtn>
          </div>
        </section>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default ProgramContent;

const Child = ({ title, program_items, index }) => {
  const [state, setState] = useState(false);
  const { state: details } = useContext(MyContext);

  return (
    <div
      style={{ border: `2px solid ${details.color}` }}
      className="border  border-primary rounded-md overflow-hidden  p-5 cursor-pointer max-sm:3"
      onClick={() => setState(!state)}>
      <div className={clsx("      ")}>
        <div className="flex justify-between items-center">
          {" "}
          <p
            style={{ color: details.color }}
            className="text-base flex gap-1 text-primary font-medium ">
            {" "}
            <span>{index + 1}. </span> {title}{" "}
          </p>
          <div
            style={{ color: details.color }}
            className="text-2xl text-primary">
            <IoIosArrowDown
              className={clsx(
                state ? "rotate-180" : "",
                "transition-all duration-300"
              )}
            />
          </div>
        </div>
      </div>
      <motion.div
        transition={{ duration: 0.3 }}
        animate={{ height: state ? "auto" : "0px", overflow: "hidden" }}>
        <div className="mt-3 space-y-[0.4rem]">
          {program_items.map((value, index) => {
            return (
              <div className="px-5  flex items-center max-w-3xl gap-3 text-sm font-medium text-slate-800 max-sm:items-start">
                {" "}
                <span className="self-start">
                  {" "}
                  <FaHandPointRight
                    style={{ color: details.color }}
                    className="text-primary mt-[0.1rem]"
                  />
                </span>
                <span>{value}</span>
              </div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};
